import * as z from 'zod';

import { booleanMutationSchema } from '@/_schemas/generic';

import { partnerQuerySchema } from './partner-query-schema';

export const partnerUpdateSchema = partnerQuerySchema
  .pick({
    id: true,
    name: true,
    code: true,
    website: true,
    email: true,
    // Termination & Notice Tracking
    termination_notice_date: true,
    required_notice_days: true,
    override_termination_date: true,
    termination_extension_days: true,
    // Tail Commission Settings
    tail_enabled: true,
    tail_percentage: true,
    tail_duration_months: true,
    tail_flat_monthly_payout: true,
    tail_start_month: true,
    // Transition Period Tail Settings
    transition_tail_enabled: true,
    transition_tail_percentage: true,
    transition_tail_duration_months: true,
    transition_tail_start_month: true,
  })
  .extend({
    status: z.string(),
    logo: z.array(z.number()).nullable(),
    logo_light: z.array(z.number()).nullable(),
    icon: z.array(z.number()).nullable(),

    handle_invoicing: booleanMutationSchema(),
  });

export type PartnerUpdateSchema = z.infer<typeof partnerUpdateSchema>;

export const partnerCreateSchema = partnerUpdateSchema.omit({
  id: true,
  logo: true,
  logo_light: true,
  icon: true,
});

export type PartnerCreateSchema = z.infer<typeof partnerCreateSchema>;
